"use server";

import prisma from "@/lib/db";
import { BannerContent, bannerContent } from "@/utils/types/banner";

export const getCurrentBanner = async (): Promise<BannerContent | null> => {
  const now = new Date();
  return await prisma.banner.findFirst({
    ...bannerContent,
    where: {
      enabled: true,
      date_start: {
        lte: now,
      },
      date_end: {
        gte: now,
      },
    },
    orderBy: [
      {
        priority: "desc",
      },
      {
        date_end: "asc",
      },
      {
        id: "asc",
      },
    ],
  });
};
